import * as React from "react";
import { forwardRef } from "react";
const SmileySadIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 1.61538C6.26474 1.61538 1.61539 6.26473 1.61539 12c0 5.7353 4.64935 10.3846 10.38461 10.3846 5.7353 0 10.3846-4.6493 10.3846-10.3846 0-5.73527-4.6493-10.38462-10.3846-10.38462M.230774 12C.230774 5.50003 5.50004.230766 12 .230766 18.5.230766 23.7692 5.50003 23.7692 12c0 6.5-5.2692 11.7692-11.7692 11.7692C5.50004 23.7692.230774 18.5.230774 12",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.42101 17.6006c1.23868-2.4998 3.78738-4.0814 6.57729-4.0814 2.7898 0 5.3385 1.5816 6.5772 4.0814.1698.3426.0297.7579-.3129.9277-.3426.1697-.758.0296-.9277-.313-1.0051-2.0282-3.073-3.3115-5.3366-3.3115-2.26366 0-4.3316 1.2833-5.33663 3.3115-.16976.3426-.58511.4827-.92771.313-.3426-.1698-.48271-.5851-.31295-.9277m2.88668-9.61599c-.58627 0-1.06154.47527-1.06154 1.06154s.47527 1.06155 1.06154 1.06155 1.06154-.47528 1.06154-1.06155-.47527-1.06154-1.06154-1.06154m7.38461 0c-.5862 0-1.0615.47527-1.0615 1.06154s.4753 1.06155 1.0615 1.06155c.5863 0 1.0616-.47528 1.0616-1.06155s-.4753-1.06154-1.0616-1.06154",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(SmileySadIcon);
export { ForwardRef as SmileySadIcon };